export const asyncRouterMap = {
  adminUserInfo: () => import("@/views/admin/adminUserInfo/index"),
  adminRole: () => import("@/views/admin/adminRole/index"),
  adminResource: () => import("@/views/admin/adminResource/index"),
  userInfoEdit: () => import("@/views/user/userInfo/add"),
  userInfoList: () => import("@/views/user/userInfo/index"),
  userCerManage: () => import("@/views/user/userCertificate/index"),
  agentUser: () => import("@/views/agentSetting/agentUser"),
  agentInfo: () => import("@/views/agent/index"),
  projectInfo: () => import("@/views/project/index"),
  certificateLevel: () => import("@/views/certificate/index")
};
